module.exports = __webpack_public_path__ + "static/media/blof.2de56f35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/clients/blof.jpg
// module id = 282
// module chunks = 0